import React from "react";
// TEMPORARILY DISABLED - bandwidth savings
// import VideoPlayer from "react-video-js-player";

const ApplyModuleCard = (props) => {
  return (
    <>
      <div className="mainApplyModule">
        <div className="mainContainerApplyingMod">
          <div className="txtPartApplyMod">
            <p className="paraApplyModTxt">{props.para}</p>
            <div className="picPartUserAppMod">
              <img src={props.picJaqu} alt="" className="imgJaqu" />
              <p className="nameApplyModHolder">
                {" "}
                {props.name}
                <br />
                <span className="spCountryAppMod">{props.country}</span>
              </p>
            </div>
          </div>
          {/* TEMPORARILY DISABLED - video player removed for bandwidth savings */}
          <div className="mainVideoApplyMod" style={{display:'flex',alignItems:'center',justifyContent:'center',minHeight:'200px',background:'#111',borderRadius:'12px'}}>
            <p style={{color:'#888',fontSize:'14px',textAlign:'center'}}>Video temporarily unavailable</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default ApplyModuleCard;
